/* eslint-disable */
// Auto-generated at build time by scripts/generate-config.js — DO NOT EDIT
const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_appsync_graphqlEndpoint": "https://d7tzx7px2rgjxpiykrnpcgghle.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-west-2:341565c4-99ba-4b1f-a03b-dde44a636791",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_5npRxEQou",
    "aws_user_pools_web_client_id": "4acj5d2ki5itakq6bmig8uuh0g",
    "oauth": {
        "domain": "taps-dmafu4y80mc7f-main.auth.eu-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://taps.iam.aws.onsdigital.uk/",
        "redirectSignOut": "https://taps.iam.aws.onsdigital.uk/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_additionalAuthenticationTypes": "AWS_IAM"
};

export default awsmobile;
